import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useProductTileContext } from '@as/cotopaxi';
import { findColor, isOnlyOneSizeProduct } from '@as-react/common-utils';
import { SelectAlpha, TextAlpha } from '@yonderland/andes-react';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { mapAndesSizeSelectOptions, selectOptionLabel } from '../../../../util/ProductUtil';
export const SizeSelect = ({ onChange, sizeSelectError }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const id = useId();
    const { colors, activeColorId, productId, selectedSku } = useProductTileContext();
    const selectedColor = findColor(colors, activeColorId);
    const oneSizeProduct = isOnlyOneSizeProduct(selectedColor.sizes);
    const items = mapAndesSizeSelectOptions(selectedColor.sizes, true);
    const handleSelect = (item) => {
        onChange(String(item.id));
    };
    return !oneSizeProduct ? (_jsx(SelectAlpha, { input: {
            id: `mini_pdp_product_tile_size_select_${id}`,
            placeholder: t('pdp.sizeSmall'),
            error: sizeSelectError ? t('pdp.forgotSize') : undefined,
            required: true,
        }, name: `size_select_look_${productId}`, testId: "size_select", items: items, value: selectedSku || undefined, onSelect: handleSelect })) : (_jsxs(_Fragment, { children: [_jsx(TextAlpha, { as: "span", variant: "bodyS", strong: true, children: t('pdp.size') }), ' ', _jsx(TextAlpha, { as: "span", variant: "bodyS", children: items.length > 0 && selectedColor.sizes[0] ? selectOptionLabel(selectedColor.sizes[0]) : undefined })] }));
};
